import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { CreateBankAccountsMutationRequest, CreateBankAccountsMutationResponse, CreateBankAccounts400, CreateBankAccounts500 } from "../types/CreateBankAccounts";

/**
 * @summary Создать банковские счета организации
 * @link /api/lk/organization/bank-account
 */

export function useCreateBankAccounts <TData = CreateBankAccountsMutationResponse, TError = CreateBankAccounts400 | CreateBankAccounts500, TVariables = CreateBankAccountsMutationRequest>(options: {
          mutation?: UseMutationOptions<ResponseConfig<TData>, TError, TVariables>,
          client?: Partial<Parameters<typeof client<TData, TError, TVariables>>[0]>,
      } = {}): UseMutationResult<ResponseConfig<TData>, TError, TVariables> {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};

  return useMutation<ResponseConfig<TData>, TError, TVariables>({
    mutationFn: (data) => {
      
      return client<TData, TError, TVariables>({
        method: "post",
        url: `/api/lk/organization/bank-account`,
        data,
        
        
        ...clientOptions
      });
    },
    ...mutationOptions
  });
};
